class Constants {
    static API_URL = "https://v09x8txzfe.execute-api.ap-northeast-1.amazonaws.com/prod";
    static HOME_URL = "https://anotango.com";
}

export default Constants;
